<template>
  <div>
    <iframe width="100%" height="650px"
      src="https://lookerstudio.google.com/embed/u/0/reporting/fdaa76e5-421e-4b28-89de-504564c84bd5/page/p_qvs86wwwpd"
      frameborder="0" style="border:0" allowfullscreen></iframe>
  </div>
</template>

<script>
export default {
}
</script>
